module.exports = __webpack_public_path__ + "img/icon_pod_outlined.5fb8335b.svg";